import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { QueryParameters, Routes } from "@lifeat/shared/system/RouteConstants";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { LifeAtBodyPrimary, LifeAtHeaderPrimary } from "@common/LifeAtText/LifeAtText";
import useQueryParam from "@hooks/useQueryParam";
import DesktopAppIcon from "@resources/logos/desktopApp/LifeAt_DesktopApp_MenubarIcon.svg";
import { redirectTo } from "@util/BrowserUtil";
import { BrowserUtil } from "@util/index";
import { DEEP_LINK_PREFIX_LOCAL } from "../../features/desktop-app/DesktopAppConstants";
import InfoPageTemplate from "./templates/InfoPageTemplate";

const StyledInfoPage = styled(InfoPageTemplate)`
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
`;

const Logo = styled.div`
    height: 64px;
    width: 64px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: black;
    border-radius: 12px;

    margin-bottom: 25px;
`;

const PageHalf = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 80px;
`;

const RightHalf = styled(PageHalf)`
    padding: unset;
    background-color: lightgrey;
    width: 50%;
    height: 100%;
    justify-content: center;
`;

const ActionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    margin: 25px 0;
`;

const ActionButton = styled(LifeAtButtonV2)`
    margin-right: 10px;
`;

const StyledImg = styled.img`
    height: auto;
    width: 100%;
`;

const IMAGE_SRC =
    "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2Fonboarding%2Femail_verification_landing_img.png?alt=media&token=32b338d1-33da-4885-85ef-30013e7bf97b";

const PAGE_TITLE = "Thanks for verifying your email!";
const PAGE_SUBTITLE = "Click below to return to LifeAt and keep exploring";
const CLICK_TO_OPEN_APP_BTN_LABEL = "Open Desktop App";
const CLICK_TO_CONTINUE_TO_SITE_BTN_LABEL = "Open in browser";
const CONTINUE_BTN_LABEL = "Continue";
// const DOWNLOAD_DESKTOP_APP_BTN_LABEL = "Don't have the desktop app? Download it here";

function EmailVerificationLandingPage() {
    const history = useHistory();
    const query = useQueryParam();

    const desktopDeepLinkBase = window.location.origin.includes("localhost")
        ? DEEP_LINK_PREFIX_LOCAL
        : process.env.DESKTOP_APP_DEEPLINK_PREFIX;
    const desktopRedirUrl = decodeURIComponent(query.get(QueryParameters.RedirectSuccess) ?? "");
    const desktopDeepLink = desktopRedirUrl
        ? `${desktopDeepLinkBase}?${QueryParameters.RedirectSuccess}=${encodeURIComponent(desktopRedirUrl)}`
        : undefined;

    const continueToAppRedir = query.has(QueryParameters.RedirectSuccess)
        ? decodeURIComponent(query.get(QueryParameters.RedirectSuccess) ?? "")
        : `/${Routes.App}`;

    useEffect(() => {
        if (desktopDeepLink == null) {
            redirectTo(continueToAppRedir);
        }
    }, [continueToAppRedir, desktopDeepLink]);

    return (
        <StyledInfoPage forceLightMode={true}>
            <PageHalf>
                <Logo>
                    <DesktopAppIcon />
                </Logo>

                <LifeAtHeaderPrimary>{PAGE_TITLE}</LifeAtHeaderPrimary>
                <LifeAtBodyPrimary>{PAGE_SUBTITLE}</LifeAtBodyPrimary>

                <ActionsContainer>
                    {desktopDeepLink && (
                        <ActionButton
                            onClick={() => BrowserUtil.openPage(desktopDeepLink, false)}
                            variant={"solid"}
                            overrideBackgroundColor={"#333333"}
                            overrideTextColor={"#FFFFFF"}
                            disableHover={true}
                        >
                            {CLICK_TO_OPEN_APP_BTN_LABEL}
                        </ActionButton>
                    )}

                    <ActionButton onClick={() => history.push(continueToAppRedir)} variant={"outline"}>
                        {desktopDeepLink ? CLICK_TO_CONTINUE_TO_SITE_BTN_LABEL : CONTINUE_BTN_LABEL}
                    </ActionButton>
                </ActionsContainer>
            </PageHalf>

            <RightHalf>
                <StyledImg src={IMAGE_SRC} />
            </RightHalf>
        </StyledInfoPage>
    );
}
export default EmailVerificationLandingPage;
